export const WFA_SESSION_ALL_ISSUES_CSV_FILE_NAME_PREFIX = 'wfa-session-issues';
